import { Expose } from 'class-transformer'

export class SaleSummary {
  @Expose()
  donationSummary: string

  @Expose()
  mangaChapterSalesSummary: string

  @Expose()
  mangaEbookSalesSummary: string

  @Expose()
  novelChapterSalesSummary: string

  @Expose()
  novelEbookSalesSummary: string

  @Expose()
  totalWriterIncome: string

  @Expose({ name: 'totalWriterIncomeCumulative' })
  totalWriterIncomeLastMonth: string

  @Expose()
  writerId: number
}
